// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3btjt","buttons":"styles_buttons__1DdvQ"};